import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { PlansTableRowDefinition } from '../plans-table/plans-table.model';
import { PlanWithLimits } from '../../../shared/models/plans';
import { Observable } from 'rxjs';

@Component({
  selector: 'cc-plan-features-table',
  templateUrl: './plan-features-table.component.html',
  styleUrls: ['./plan-features-table.component.scss']
})
export class PlanFeaturesTableComponent implements OnInit {
  @Input() public rowsDefinition: PlansTableRowDefinition[];
  @Input() public plans$: Observable<PlanWithLimits[]>;
  @Input() public fullWidthStaticHeader = false;
  @ContentChild(TemplateRef) public planHeaderRef: TemplateRef<any>;

  public plans: PlanWithLimits[];

  public planColumns: { plan: PlanWithLimits; name: string }[];
  public planColumnHeaders: string[];

  public KEY_FEATURES_COLUMN_HEADER = 'KEY_FEATURES_COLUMN_HEADER';

  constructor() {}

  ngOnInit() {
    this.plans$.subscribe((_plans: PlanWithLimits[]) => {
      this.plans = _plans;
      this.planColumns = this.plans.map(plan => ({ plan, name: plan.name }));
      this.planColumnHeaders = [this.KEY_FEATURES_COLUMN_HEADER, ...this.planColumns.map(a => a.plan.id)];
    });
  }
}
